"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedCountDownDuration = exports.getCountDownText = exports.getCountDownColor = exports.TWENTY_FOUR_HOURS_IN_SECONDS = exports.ONE_MINUTE_IN_SECONDS = exports.FIVE_MINUTES_IN_SECONDS = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _StreamStates = require("../../constants/StreamStates");
var _StreamStoppedReasons = require("../../constants/StreamStoppedReasons");
var TWENTY_FOUR_HOURS_IN_SECONDS = exports.TWENTY_FOUR_HOURS_IN_SECONDS = 86400;
var FIVE_MINUTES_IN_SECONDS = exports.FIVE_MINUTES_IN_SECONDS = 300;
var ONE_MINUTE_IN_SECONDS = exports.ONE_MINUTE_IN_SECONDS = 60;
var getCountDownText = exports.getCountDownText = function getCountDownText(serverTimeToStart, streamStatus) {
  if (serverTimeToStart <= 0 || streamStatus === _StreamStates.STARTED) {
    return 'Time remaining';
  }
  return 'Presentation scheduled';
};
var getFormattedCountDownDuration = exports.getFormattedCountDownDuration = function getFormattedCountDownDuration(serverTimeToStart, serverTimeToEnd, streamStatus) {
  var duration;
  if (serverTimeToStart >= TWENTY_FOUR_HOURS_IN_SECONDS) {
    duration = 0;
  } else if (serverTimeToEnd <= 0) {
    duration = 0;
  } else if (streamStatus === _StreamStates.STARTED) {
    duration = serverTimeToEnd;
  } else if (serverTimeToStart < TWENTY_FOUR_HOURS_IN_SECONDS && serverTimeToStart > 0) {
    duration = serverTimeToStart;
  } else if (serverTimeToStart <= 0 && serverTimeToEnd > 0) {
    duration = serverTimeToEnd;
  } else {
    duration = 0;
  }
  return _moment["default"].utc(duration * 1000).format('HH:mm:ss');
};
var getCountDownColor = exports.getCountDownColor = function getCountDownColor(serverTimeToStart, serverTimeToEnd, streamStatus, stoppedReason) {
  // if outside broadcast window and past end time
  if (serverTimeToStart <= 0 && serverTimeToEnd <= 0) {
    return 'dark';
  }

  // if outside of broadcast window, before stream starts
  if (serverTimeToStart <= TWENTY_FOUR_HOURS_IN_SECONDS && serverTimeToStart > FIVE_MINUTES_IN_SECONDS) {
    return 'default';
  }

  // if inside broadcast window and stream has stopped|stopping and stream stopped by user
  if (serverTimeToStart <= 0 && serverTimeToEnd > 0 && [_StreamStates.STOPPING, _StreamStates.STOPPED].includes(streamStatus) && stoppedReason === _StreamStoppedReasons.STOPPED_BY_USER) {
    return 'default';
  }

  // if it is less than 5 minutes to start time and stream has not started
  if (serverTimeToStart <= FIVE_MINUTES_IN_SECONDS && serverTimeToStart > 0 && ![_StreamStates.STARTING, _StreamStates.STARTED].includes(streamStatus)) {
    return 'warning';
  }

  // if it is less than 5 minutes to start time and greater than 5 minutes to end time and stream is starting
  if (serverTimeToStart <= FIVE_MINUTES_IN_SECONDS && serverTimeToEnd > FIVE_MINUTES_IN_SECONDS && streamStatus === _StreamStates.STARTING) {
    return 'warning';
  }

  // if it is less than 5 minutes to start time and greater than 5 minutes to end time and stream is started
  if (serverTimeToStart <= FIVE_MINUTES_IN_SECONDS && serverTimeToEnd > FIVE_MINUTES_IN_SECONDS && streamStatus === _StreamStates.STARTED) {
    return 'default';
  }

  // if inside broadcast window and stream has never started
  if (serverTimeToStart <= 0 && serverTimeToEnd > 0 && streamStatus === _StreamStates.PENDING) {
    return 'alert';
  }

  // if inside broadcast window, and it is between 1-5minutes to end time and stream is active
  if (serverTimeToStart <= 0 && serverTimeToEnd > ONE_MINUTE_IN_SECONDS && serverTimeToEnd < FIVE_MINUTES_IN_SECONDS && [_StreamStates.STARTING, _StreamStates.STARTED].includes(streamStatus)) {
    return 'warning';
  }

  // if inside broadcast window, and it is less than 1 minute to end time and stream is active
  if (serverTimeToStart <= 0 && serverTimeToEnd < ONE_MINUTE_IN_SECONDS && [_StreamStates.STARTING, _StreamStates.STARTED].includes(streamStatus)) {
    return 'alert';
  }
  return 'default';
};